export default __webpack_public_path__ + "static/media/img_care_team@3x.819c2953.png";